import Construction from "./pages/Construction";

function App() {
  return (
    <>
      <Construction />
    </>
  );
}

export default App;
